export const shouldUseVirtualizedMemoryList = ({
  platform,
  fabricEnabled,
  memoryCount,
}) => platform === 'android' && !fabricEnabled && memoryCount > 0;
